module.exports = __webpack_public_path__ + "static/media/polish-german-icon.33ed8544.svg";